import { GithubWebhookDeliverySchema } from "@core/domains/github";
import { apiEndpoint, internalApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { MEMORY_SERVICE } from "../config/index.ts";

export const memoryInternalApi = internalApi(
  { domain: API_DOMAIN, path: `${MEMORY_SERVICE.LABEL}/int` },
  {
    ingestGithubEvent: apiEndpoint({
      body: z.object(
        { delivery: GithubWebhookDeliverySchema },
        { delivery: "The GitHub webhook delivery the account service relays" },
      ),
      response: z.void(),
    }),
  },
);
